/** Печатные документы: stock. ky/en/uz — с теми же ключами (проверяется типом). */
import type { Shape } from "./shape";

export const ru = {
  receipt: "Приходная накладная",
  writeoff: "Акт списания",
  return: "Накладная на возврат поставщику",
  dated: "от {{date}}",
  basis: "Основание",
  priceUnit: "Цена за ед.",
  handedOver: "Сдал",
  accepted: "Принял",
  responsible: "Материально ответственное лицо",
  commission: "Член комиссии",
  approved: "Утвердил",
  issued: "Выдал",
  gotMoney: "Получил",
  filter: "Отбор",
  register: "Реестр",
  registerReceipts: "Реестр закупок",
  registerWriteoffs: "Реестр списаний",
  registerReturns: "Реестр возвратов поставщикам",
  registerExpenses: "Реестр расходов",
  byCategory: "По категориям",
  payablesTitle: "Задолженность перед поставщиками",
  onDate: "на {{date}}",
  paymentTitle: "Оплата поставщику",
  allocations: "Зачтено в закупки",
  purchaseOf: "Закупка от {{date}}",
  advance: "Аванс (не зачтено)",
  debtsTitle: "Долги клиентов",
  debtStatement: "Выписка по долгу клиента",
  statement: "Выписка по долгу",
  customer: "Клиент",
  operation: "Операция",
  method: "Способ оплаты",
  charged: "Начислено",
  repaid: "Погашено",
  balanceAfter: "Долг после",
  currentDebt: "Текущий долг",
  requestTitle: "Заявка на закупку № {{n}}",
  applicant: "Заявитель",
  created: "Создана",
  history: "История",
  event: "Событие",
  who: "Кто",
  when: "Когда",
  suggestTitle: "Что заказать",
  suggestParams: "Запас на {{cover}} дн., история расхода {{history}} дн., страховой запас +{{safety}}%",
  estimateTotal: "Ориентировочно",
};

export const en: Shape<typeof ru> = {
  receipt: "Goods received note",
  writeoff: "Write-off act",
  return: "Return to supplier note",
  dated: "dated {{date}}",
  basis: "Basis",
  priceUnit: "Unit price",
  handedOver: "Delivered by",
  accepted: "Received by",
  responsible: "Person in charge",
  commission: "Committee member",
  approved: "Approved by",
  issued: "Paid by",
  gotMoney: "Received by",
  filter: "Filter",
  register: "Register",
  registerReceipts: "Purchases register",
  registerWriteoffs: "Write-offs register",
  registerReturns: "Supplier returns register",
  registerExpenses: "Expenses register",
  byCategory: "By category",
  payablesTitle: "Accounts payable to suppliers",
  onDate: "as of {{date}}",
  paymentTitle: "Supplier payment",
  allocations: "Applied to purchases",
  purchaseOf: "Purchase of {{date}}",
  advance: "Advance (not applied)",
  debtsTitle: "Customer debts",
  debtStatement: "Customer debt statement",
  statement: "Debt statement",
  customer: "Customer",
  operation: "Operation",
  method: "Payment method",
  charged: "Charged",
  repaid: "Repaid",
  balanceAfter: "Debt after",
  currentDebt: "Current debt",
  requestTitle: "Purchase request No. {{n}}",
  applicant: "Requested by",
  created: "Created",
  history: "History",
  event: "Event",
  who: "By",
  when: "When",
  suggestTitle: "What to order",
  suggestParams: "Stock for {{cover}} days, usage history {{history}} days, safety stock +{{safety}}%",
  estimateTotal: "Estimated",
};

export const ky: Shape<typeof ru> = {
  receipt: "Кирүү накладнойу",
  writeoff: "Эсептен чыгаруу актысы",
  return: "Жеткирүүчүгө кайтаруу накладнойу",
  dated: "{{date}} күнкү",
  basis: "Негиз",
  priceUnit: "Бирдиктин баасы",
  handedOver: "Тапшырды",
  accepted: "Кабыл алды",
  responsible: "Материалдык жооптуу адам",
  commission: "Комиссиянын мүчөсү",
  approved: "Бекитти",
  issued: "Берди",
  gotMoney: "Алды",
  filter: "Фильтр",
  register: "Реестр",
  registerReceipts: "Сатып алуулардын реестри",
  registerWriteoffs: "Эсептен чыгаруулардын реестри",
  registerReturns: "Жеткирүүчүлөргө кайтаруулардын реестри",
  registerExpenses: "Чыгымдардын реестри",
  byCategory: "Категориялар боюнча",
  payablesTitle: "Жеткирүүчүлөр алдындагы карыз",
  onDate: "{{date}} абалы боюнча",
  paymentTitle: "Жеткирүүчүгө төлөм",
  allocations: "Сатып алууларга эсептелди",
  purchaseOf: "{{date}} күнкү сатып алуу",
  advance: "Аванс (эсептеле элек)",
  debtsTitle: "Кардарлардын карыздары",
  debtStatement: "Кардардын карызы боюнча көчүрмө",
  statement: "Карыз боюнча көчүрмө",
  customer: "Кардар",
  operation: "Операция",
  method: "Төлөө ыкмасы",
  charged: "Эсептелди",
  repaid: "Төлөндү",
  balanceAfter: "Кийинки карыз",
  currentDebt: "Учурдагы карыз",
  requestTitle: "Сатып алууга өтүнмө № {{n}}",
  applicant: "Өтүнмө берген",
  created: "Түзүлдү",
  history: "Тарых",
  event: "Окуя",
  who: "Ким",
  when: "Качан",
  suggestTitle: "Эмнени буйрутма кылуу керек",
  suggestParams: "{{cover}} күнгө запас, чыгым тарыхы {{history}} күн, камдык запас +{{safety}}%",
  estimateTotal: "Болжол менен",
};

export const uz: Shape<typeof ru> = {
  receipt: "Kirim yuk xati",
  writeoff: "Hisobdan chiqarish dalolatnomasi",
  return: "Yetkazib beruvchiga qaytarish yuk xati",
  dated: "{{date}} sanali",
  basis: "Asos",
  priceUnit: "Birlik narxi",
  handedOver: "Topshirdi",
  accepted: "Qabul qildi",
  responsible: "Moddiy javobgar shaxs",
  commission: "Komissiya a'zosi",
  approved: "Tasdiqladi",
  issued: "Berdi",
  gotMoney: "Oldi",
  filter: "Filtr",
  register: "Reyestr",
  registerReceipts: "Xaridlar reyestri",
  registerWriteoffs: "Hisobdan chiqarishlar reyestri",
  registerReturns: "Yetkazib beruvchilarga qaytarishlar reyestri",
  registerExpenses: "Xarajatlar reyestri",
  byCategory: "Toifalar bo'yicha",
  payablesTitle: "Yetkazib beruvchilar oldidagi qarz",
  onDate: "{{date}} holatiga",
  paymentTitle: "Yetkazib beruvchiga to'lov",
  allocations: "Xaridlarga hisoblandi",
  purchaseOf: "{{date}} sanali xarid",
  advance: "Avans (hisoblanmagan)",
  debtsTitle: "Mijozlar qarzlari",
  debtStatement: "Mijoz qarzi bo'yicha ko'chirma",
  statement: "Qarz bo'yicha ko'chirma",
  customer: "Mijoz",
  operation: "Operatsiya",
  method: "To'lov usuli",
  charged: "Hisoblandi",
  repaid: "To'landi",
  balanceAfter: "Keyingi qarz",
  currentDebt: "Joriy qarz",
  requestTitle: "Xarid uchun ariza № {{n}}",
  applicant: "Ariza beruvchi",
  created: "Yaratildi",
  history: "Tarix",
  event: "Hodisa",
  who: "Kim",
  when: "Qachon",
  suggestTitle: "Nima buyurtma qilish kerak",
  suggestParams: "{{cover}} kunlik zaxira, sarf tarixi {{history}} kun, xavfsizlik zaxirasi +{{safety}}%",
  estimateTotal: "Taxminan",
};
